import React from "react";
import AppTemplate from "../components/PageServiceStop";

const PageServiceStop: React.FC = () => {
  return (
    <AppTemplate>
      <>ダッシュボード</>;
    </AppTemplate>
  );
};

export default PageServiceStop;
